function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useTheme, matchColorMap } from "../theme";
import DefaultStepIndicator from 'react-native-step-indicator';
const defaultStyles = {
  stepIndicatorSize: 30,
  currentStepIndicatorSize: 40,
  separatorStrokeWidth: 2,
  currentStepStrokeWidth: 3,
  stepStrokeCurrentColor: 'primary',
  stepStrokeWidth: 3,
  separatorStrokeFinishedWidth: 4,
  stepStrokeFinishedColor: 'primary',
  stepStrokeUnFinishedColor: 'placeholder',
  separatorFinishedColor: 'primary',
  separatorUnFinishedColor: 'placeholder',
  stepIndicatorFinishedColor: 'primary',
  stepIndicatorUnFinishedColor: 'background',
  stepIndicatorCurrentColor: 'background',
  stepIndicatorLabelFontSize: 13,
  currentStepIndicatorLabelFontSize: 13,
  stepIndicatorLabelCurrentColor: 'primary',
  stepIndicatorLabelFinishedColor: 'background',
  stepIndicatorLabelUnFinishedColor: 'placeholder',
  labelColor: 'text',
  labelSize: 13,
  currentStepLabelColor: 'primary'
};

const StepIndicator = props => {
  const {
    customStyles = defaultStyles
  } = props,
        rest = _objectWithoutProperties(props, ["customStyles"]);

  const styles = _objectSpread(_objectSpread({}, defaultStyles), customStyles);

  const theme = useTheme();
  return /*#__PURE__*/React.createElement(DefaultStepIndicator, _extends({}, rest, {
    // @ts-ignore
    customStyles: matchColorMap(styles, theme)
  }));
}; // export {
//   StepIndicatorStyles,
// } from 'react-native-step-indicator/src/types'


export default StepIndicator;